// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, Breadcrumbs, Container, Skeleton, Stack } from '@mui/material';

export function PurchaseOrderDetailsSkeleton() {
  return (
    <Container maxWidth="xl">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        marginTop={3}
        paddingX={3}
      >
        <Breadcrumbs separator="›">
          <Skeleton variant="text" width={80} />
          <Skeleton variant="text" width={100} />
        </Breadcrumbs>
        <Stack direction="row" spacing={1}>
          <Skeleton variant="rectangular" width={80} height={36} />
          <Skeleton variant="rectangular" width={120} height={36} />
        </Stack>
      </Stack>

      <Stack paddingX={{ xs: 1, md: 3 }} spacing={1} marginTop={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="text" width={100} height={40} />
          <Skeleton variant="text" width={150} height={24} />
        </Stack>
      </Stack>

      <Stack
        direction={{ xs: 'column', md: 'row' }}
        paddingX={{ xs: 1, md: 3 }}
        spacing={2}
        marginY={3}
      >
        <Stack
          direction={{ xs: 'row', md: 'column' }}
          borderTop="1px solid transparent"
          spacing={1}
        >
          <Skeleton variant="text" width={100} height={32} />
          <Skeleton variant="text" width={110} height={32} />
        </Stack>

        <Box flexGrow={1} paddingLeft={{ xs: 0, md: 2 }}>
          <Stack spacing={2}>
            <Skeleton variant="rectangular" width="100%" height={300} />
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}
